import { render, staticRenderFns } from "./group_index.vue?vue&type=template&id=56b27232&scoped=true"
import script from "./group_index.vue?vue&type=script&lang=js"
export * from "./group_index.vue?vue&type=script&lang=js"
import style0 from "./group_index.vue?vue&type=style&index=0&id=56b27232&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b27232",
  null
  
)

export default component.exports